import React, { useState, useEffect } from 'react';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import './AddBull.css';

const AddBullForm = (props) => {
  const { t } = useTranslation();
  const [breeds, setBreeds] = useState([]);
  const [tag, setTag] = useState('');
  const [breed, setBreed] = useState('');
  const [tagStatus, setTagStatus] = useState(null); // null | 'checking' | 'ok' | 'not_found' | 'not_male'

  useEffect(() => {
    Fetch('api/data/breeds', 'get', null, (data) => setBreeds(data || []));
  }, []);

  // Best-effort client-side lookup, purely for UX — the server re-validates
  // (and is the actual authority) on submit either way, since this same tag
  // is what reproduction.HandleBirth will later resolve a calf's father
  // through, so it can't be left unvalidated.
  const onTagBlur = () => {
    const t = tag.trim();
    if (!t) { setTagStatus(null); return; }
    setTagStatus('checking');
    Fetch(`api/animals/${encodeURIComponent(t)}`, 'get', null,
      (animal) => {
        if (animal.sex !== 'm') {
          setTagStatus('not_male');
          return;
        }
        setTagStatus('ok');
        if (animal.breed) setBreed(animal.breed);
      },
      () => setTagStatus('not_found')
    );
  };

  return (
    <>
      <input type="text" name="name"
        placeholder={t("bull_name")} required />

      <select name="breed" value={breed} onChange={(e) => setBreed(e.target.value)}>
        <option value="">— {t("bull_breed")} —</option>
        {breeds.map(b => (
          <option key={b._id} value={b.name}>{b.name}</option>
        ))}
      </select>

      <input type="text" name="tag"
        value={tag}
        onChange={(e) => { setTag(e.target.value); setTagStatus(null); }}
        onBlur={onTagBlur}
        placeholder={t("bull_tag")} />
      <div>{t("bull_tag_hint")}</div>
      {tagStatus === 'not_found' && <div className="bull-tag-warning">{t('bull_tag_not_found')}</div>}
      {tagStatus === 'not_male' && <div className="bull-tag-warning">{t('bull_tag_not_male')}</div>}

      <input type="text" name="matches"
        placeholder={t("aliases")} />
      <div>{t("aliases_hint")}</div>
    </>
  );
}

const getBodyFromForm = (formData) => {
  const name = formData.get("name");
  const breed = formData.get("breed") || '';
  const tag = formData.get("tag") || '';
  const extra = formData.get("matches") || '';
  const matches = extra ? `${name};${extra}` : name;
  return JSON.stringify({ name, breed, tag, matches });
}

export const AddBull = (props) => {
  const { t } = useTranslation();
  return (
    <DataCollectionAdd
      collection="reproduction.bulls"
      getBodyFromForm={getBodyFromForm}
      formElements={AddBullForm}
      onSuccess={props.onSuccess}
      successMsg={t('bull_added_success')}
    />
  );
}

export default AddBull;
